import { useQuery } from '@tanstack/react-query';
import useAuthRequest from '../services/requests.service';
import { getParamsFilter } from '../utils/function';

// Hook pour récupérer les employés d'une entreprise
export const useEmployees = (pageId) => {
  const request = useAuthRequest();
  
  return useQuery({
    queryKey: ['employees', pageId],
    queryFn: async () => {
      const newfilter = { company: pageId, status: "active" };
      const param = getParamsFilter(newfilter);
      const res = await request.getDataAPI(`/subscription?${param}`);
      return res;
    },
    enabled: !!pageId,
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchOnWindowFocus: false,
    retry: 1,
  });
}; 